import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import IntegrationImage from "../../../../integrations/components/IntegrationImage";
import TextIntegrationStyle from "../../TextIntegrationStyle";
import { getServerGroupsRows } from "./checkRowsServerData";

const ServerGroupsView = ({ entityData }) => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    setRows(getServerGroupsRows(entityData));
  }, [entityData]);

  const toolsGroup = {
    crowdstrike: rows.filter((row) => row?.source === "crowdstrike"),
    microsoft_sccm: rows.filter((row) => row?.source === "microsoft_sccm"),
    microsoft_defender_endpoint: rows.filter(
      (row) => row?.source === "microsoft_defender_endpoint"
    ),
    microsoft_active_directory: rows.filter(
      (row) => row?.source === "microsoft_active_directory"
    ),
  };

  const renderGroup = (groupName, groupData) =>
    groupData.length > 0 && (
      <Box display={"flex"} gap={1} flexDirection={"column"} mb={1}>
        <Box display={"flex"} gap={1} alignItems={"center"}>
          <Box display={"flex"}>
            {groupData[0] && (
              <IntegrationImage
                name={groupData[0].source}
                width={"16px"}
                newLogo={true}
              />
            )}
          </Box>
          <Typography variant={"subtitle2"}>{groupName}</Typography>
        </Box>
        <Box display={"flex"} gap={1} ml={3} flexDirection={"column"}>
          {groupData.map((item, index) => (
            <TextIntegrationStyle
              key={index}
              title={""}
              value={item.group_name}
            ></TextIntegrationStyle>
          ))}
        </Box>
      </Box>
    );

  return (
    rows.length > 0 && (
      <Box display={"flex"} flexDirection={"column"} gap={1}>
        {renderGroup("CrowdStrike", toolsGroup.crowdstrike)}
        {renderGroup("Microsoft SCCM", toolsGroup.microsoft_sccm)}
        {renderGroup(
          "Microsoft Defender Endpoint",
          toolsGroup.microsoft_defender_endpoint
        )}
        {renderGroup(
          "Microsoft Active Directory",
          toolsGroup.microsoft_active_directory
        )}
      </Box>
    )
  );
};

export default ServerGroupsView;
